import React from 'react'
import Link from 'gatsby-link'

//  Styles
import styles from './ThemeLink.module.scss'

const ThemeLink = ( props ) => (
  <Link className={ [styles.theme__link, styles[props.className]].join(" ") } to={ props.node.path }>
    <h3 className={ styles.theme__link__title }>{ props.node.title }</h3>
    <div className={ styles.theme__link__statistic }>
      <h2>{ props.node.stat.prefix ? <sup>{ props.node.stat.prefix }</sup> : "" }<strong>{ props.node.stat.number }</strong>{ props.node.stat.suffix }</h2>
      <p>{ props.node.stat.text }</p>
    </div>
  </Link>
)

export default ThemeLink



// WEBPACK FOOTER //
// ./src/components/ThemeLink/ThemeLink.js